// SOMMET ZÜRICH watch configurator data

// Swatch chip colors — sampled from the actual master photos (dial, hands,
// strap) so the little color circles in the configurator match what the
// real photo-based result actually looks like, instead of a guessed color.
export const COLOR_HEX = {
  silver: "#B8B8B4",
  black: "#242424",
  dark_blue: "#232F72",
  white: "#F2EFE8",
  green: "#2C6249",
  gold: "#BBA57C",
  rose_gold: "#B98A7A",
  brown: "#7D4A3B",
  bronze: "#BF905D",
};

export const COLOR_LABELS = {
  de: {
    silver: "Silber",
    black: "Schwarz",
    dark_blue: "Dunkelblau",
    white: "Weiß",
    green: "Grün",
    gold: "Gold",
    rose_gold: "Roségold",
    brown: "Braun",
    bronze: "Bronze",
  },
  en: {
    silver: "Silver",
    black: "Black",
    dark_blue: "Dark Blue",
    white: "White",
    green: "Green",
    gold: "Gold",
    rose_gold: "Rose Gold",
    brown: "Brown",
    bronze: "Bronze",
  },
};

// Base price and surcharges per option (in CHF)
export const BASE_PRICE = 269;

// Flat surcharge applied when a user changes a dimension from the default
export const DIMENSION_SURCHARGE = {
  case: 15,
  dial: 15,
  hands: 10,
  strap: 9,
  engraving: 25,
};

export const CASES = [
  { id: "silver", color: "silver", material: { de: "316L Edelstahl", en: "316L Steel" } },
  { id: "black",  color: "black",  material: { de: "PVD Schwarz",     en: "PVD Black" } },
  { id: "gold",   color: "gold",   material: { de: "PVD Gold",         en: "PVD Gold" } },
  { id: "rose_gold", color: "rose_gold", material: { de: "PVD Roségold", en: "PVD Rose Gold" } },
];

export const DIALS = [
  { id: "silver",    color: "silver" },
  { id: "white",     color: "white" },
  { id: "dark_blue", color: "dark_blue" },
  { id: "black",     color: "black" },
  { id: "green",     color: "green" },
];

export const HANDS = [
  { id: "silver", color: "silver" },
  { id: "bronze", color: "bronze" },
  { id: "gold",   color: "gold" },
];

// Simplified to just the material choice — no more separate color swatches
// for the strap. "steel" shows the mesh bracelet photo, "leather" shows the
// cognac leather photo.
export const STRAPS = [
  { id: "steel",   color: "silver", material: { de: "Edelstahl", en: "Steel" } },
  { id: "leather", color: "brown",  material: { de: "Leder", en: "Leather" } },
];

export const calculatePrice = ({ touched, engraving }) => {
  const t = touched || {};
  const c = t.case ? DIMENSION_SURCHARGE.case : 0;
  const d = t.dial ? DIMENSION_SURCHARGE.dial : 0;
  const h = t.hands ? DIMENSION_SURCHARGE.hands : 0;
  const s = t.strap ? DIMENSION_SURCHARGE.strap : 0;
  const e = engraving && engraving.trim() ? DIMENSION_SURCHARGE.engraving : 0;
  return BASE_PRICE + c + d + h + s + e;
};

export const DEFAULT_CONFIG = {
  caseId: "silver",
  dialId: "dark_blue",
  handsId: "silver",
  strapId: "steel",
  engraving: "",
};
